import axios from './axios'

class Course {
  getCourseList(params, viewState) {
    return axios({
      url: '/course/Subscribe/CourseList',
      method: 'post',
      headers: {
        'Ykt-ViewState': viewState
      },
      data: params
    })
  }
}

export default new Course()
